import {
  SBottomContent,
  SColumn,
  SDetail,
  SDetailLabel,
  SDetailValue,
  SHeader,
  STitleContainer,
  STitleHeader,
} from './DetailHeader.styles';

/**
 * Styles used to create the header bar that
 * commonly appears on details pages.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class DetailHeader {
  static readonly Header = SHeader;
  static readonly TitleWrapper = STitleContainer;
  static readonly Title = STitleHeader;
  static readonly Row = SBottomContent;
  static readonly Column = SColumn;
  static readonly DetailWrapper = SDetail;
  static readonly DetailLabel = SDetailLabel;
  static readonly DetailValue = SDetailValue;
}
